/**
 * 超期金额统计加载占位。
 * - chart：摘要卡 + 图区
 * - rows：明细列表行
 * 动画与首页统计卡 / 待办列表共用 dashboard-stat-skeleton-pulse。
 */
const OverdueLoadingState = ({ mode = 'chart' }) => {
	if (mode === 'rows') {
		return (
			<div className='dashboard-overdue-loading dashboard-overdue-loading--rows' role='status' aria-live='polite' aria-label='加载超期订单明细'>
				{Array.from({ length: 5 }, (_, index) => (
					<div key={index} className='dashboard-overdue-loading__row' aria-hidden='true'>
						<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--primary' />
						<span className='dashboard-overdue-loading__skeleton' />
						<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--narrow' />
						<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--sm' />
						<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--sm' />
					</div>
				))}
				<span className='visually-hidden'>加载中</span>
			</div>
		);
	}

	return (
		<div className='dashboard-overdue-loading dashboard-overdue-loading--chart' role='status' aria-live='polite' aria-label='加载超期金额图表'>
			<div className='row dashboard-overdue-stat-cards' aria-hidden='true'>
				{Array.from({ length: 4 }, (_, index) => (
					<div key={index} className='col-6 col-md-3'>
						<div className='dashboard-overdue-loading__card'>
							<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--title' />
							<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--value' />
							<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--foot' />
						</div>
					</div>
				))}
			</div>
			<div className='dashboard-overdue-loading__chart' aria-hidden='true'>
				<span className='dashboard-overdue-loading__skeleton dashboard-overdue-loading__skeleton--chart' />
			</div>
			<span className='visually-hidden'>加载中</span>
		</div>
	);
};

export default OverdueLoadingState;
